import React from "react";
import HistoryHome from "./HistoryHome";
import useInsightsHistory from "./useInsightsHistory";
import "./HistoryStyles.css";

export default function HistoryTab({
  theme, insights, filters, openPopup, collapseCommand, settings, setSettings,
}) {
  const { data, error, mutate, isValidating } = useInsightsHistory(true);

  const onManualRefresh = () => mutate();

  if (error) {
    return (
      <div className="historyRoot">
        <div className="historyTop">
          <div className="historyTitle">History</div>
          <button className="historyBtn" onClick={onManualRefresh}>Refresh</button>
        </div>
        <div className="historyError">Failed to load history.</div>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="historyRoot">
        <div className="historyTop">
          <div className="historyTitle">History</div>
          <div className="historyLoadingBtn">
            <span className="historyLoadingDot" />
            <span className="historyLoadingDot" />
            <span className="historyLoadingDot" />
          </div>
        </div>
        <div className="historySkeletonFilters" />
        <div className="historySkeletonSection">
          <div className="historySkeletonSectionHead">
            <div className="historySkeletonLine historySkeletonTitle" />
            <div className="historySkeletonLine historySkeletonChevron" />
          </div>
          <div className="historySkeletonPills">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="historySkeletonPill" style={{ animationDelay: `${i * 0.08}s` }} />
            ))}
          </div>
        </div>
        <div className="historySkeletonSection">
          <div className="historySkeletonSectionHead">
            <div className="historySkeletonLine historySkeletonTitle" style={{ width: "60%" }} />
            <div className="historySkeletonLine historySkeletonChevron" />
          </div>
          <div className="historySkeletonPills">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="historySkeletonPill" style={{ animationDelay: `${i * 0.08}s` }} />
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="historyRoot" data-theme={theme}>
      <div className="historyTop">
        <div>
          <div className="historyTitle">History</div>
          <div className="historySub">
            Auto-updates every 30s {isValidating ? "• updating…" : ""}
          </div>
        </div>
        <button className="historyBtn" onClick={onManualRefresh}>Refresh</button>
      </div>

      <HistoryHome
        history={data}
        insights={insights}
        globalFilters={filters}
        openPopup={openPopup}
        collapseCommand={collapseCommand}
        settings={settings}
        setSettings={setSettings}
      />
    </div>
  );
}
